/**
 * Images de paramétrage de l'application.
 *
 * Les valeurs sont celles attendues par l'API : elles servent de nom de fichier côté back et sont bornées par
 * `ParametreImageEnum` (Java), qui refuse tout autre nom. Elles ne peuvent donc pas être renommées d'un seul côté.
 */
export enum ParametreImageEnum {
  BACKGROUND = "background",
  LOGO = "logo",
  MENU_LOGO = "menuLogo",
}
